/**
 * @flow
 */

const host = 'https://www.universe.com';

export default {
  environment: 'production',
  api: {
    base: `${host}/api/v2`,
    redemptionsHost: 'https://redemptions.universe.com',
    host
  },
  images: {
    url: 'https://images.universe.com/'
  },
  amplitude: {
    id: '8f3073b2e3efb3028708aeca4bff06f5'
  },
  googleTagManager: {
    show: true,
    gtmId: 'GTM-K4QMLG'
  },
  uploadcare: {
    key: '6983c6f19fcba1adfe3d'
  },
  googleMapsApiKey: 'AIzaSyDLogt5ZeROXdhbZQBsxBvPDk4hkooKpGM',
  sentryDSN: 'https://78babe3f3ba14250a947a17ca5657023@sentry.io/171437',
  passbook_pass_id: 'pass.com.uni.tickets',
};



// WEBPACK FOOTER //
// ./config/production.js